import React from 'react'
import { useTranslation } from 'react-i18next'
import wifiErrorImage from '../assets/images/trendy-wifi-error-vector.jpg'

const OfflinePage: React.FC = () => {
  const { t, i18n } = useTranslation()
  const isRTL = i18n.language === 'ar'

  return (
    <div
      className={`min-h-screen flex flex-col items-center justify-center bg-white p-4 ${
        isRTL ? 'rtl' : 'ltr'
      }`}
      dir={isRTL ? 'rtl' : 'ltr'}
    >
      <div className="max-w-md w-full text-center">
        {/* Image */}
        <div className="mb-0">
          <img
            src={wifiErrorImage}
            alt="No Internet Connection"
            className="h-500 w-full max-w-sm mx-auto object-contain"
          />
        </div>

    

      
      </div>
    </div>
  )
}

export default OfflinePage

